var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tiptap',{staticClass:"u__padding-20 max-width",attrs:{"extensions":_vm.extensions,"content":_vm.content,"placeholder":"Opis","readonly":_vm.readonly},on:{"onUpdate":_vm.updateContent}})}
var staticRenderFns = []

export { render, staticRenderFns }